var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "EpIconButton",
    {
      staticClass: "add-button",
      class: { "add__button-hover": !_vm.isDisabled },
      attrs: { disabled: _vm.isDisabled, color: "primary" },
      on: {
        click: function($event) {
          return _vm.$emit("add")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "icon-container" },
        [
          _c("AddIcon", { staticClass: "add-icon", attrs: { alt: "Add icon" } })
        ],
        1
      ),
      _c("span", { staticClass: "mb-0 add-button_cursor" }, [
        _vm._v(" " + _vm._s(_vm.addRowTitle) + " ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }